const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoContactWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 91 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.111,66.999c-7.692,14.077 -22.636,23.634 -39.795,23.634c-25.011,0 -45.316,-20.306 -45.316,-45.316c0,-25.011 20.306,-45.316 45.316,-45.316c17.158,0 32.102,9.557 39.795,23.634l-40.965,0c-11.967,0 -21.683,9.716 -21.683,21.683c0,11.967 9.716,21.683 21.683,21.683l40.965,0Zm4.861,-29.431c0.434,2.518 0.661,5.107 0.661,7.748c0,2.641 -0.226,5.23 -0.661,7.748l-45.826,0c-4.276,0 -7.748,-3.472 -7.748,-7.748c0,-4.276 3.472,-7.748 7.748,-7.748l45.826,0Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoContactWhite);
export default __webpack_public_path__ + "static/media/logo-contact-white.8743f313c0825d722e45eeed935c785f.svg";
export { ForwardRef as ReactComponent };